export interface ICoordinates {
    Latitude: string;
    Longitude: string;
}

export class Coordinates implements ICoordinates {
    public Latitude: string;
    public Longitude: string;

    constructor(data: Partial<ICoordinates> = {}) {
        this.Latitude = data.Latitude || "";
        this.Longitude = data.Longitude || "";
    }
}


export interface ILocationModel {
    Address?: string;
    ZipCode?: string;
    Locality?: string;
    Street?: string;
    District?: string;
    County?: string;
    Coordinates?: ICoordinates;
    Id?: number;
    Name?: string;
    RegistDate?: string;
    RegistUser?: number;
}

export class LocationModel implements ILocationModel {
    Address?: string;
    ZipCode?: string;
    Locality?: string;
    Street?: string;
    District?: string;
    County?: string;
    Coordinates: ICoordinates;
    Id?: number;
    Name?: string;
    RegistDate?: string;
    RegistUser?: number;

    constructor(data: Partial<LocationModel> = {}) {

        this.Address = data?.Address || null;
        this.ZipCode = data?.ZipCode || null;
        this.Locality = data?.Locality || null;
        this.Street = data?.Street || null;
        this.District = data?.District || null;
        this.County = data?.County || null;
        this.Name = data?.Name || null;
        this.Coordinates = new Coordinates(data?.Coordinates);
        this.Id = data?.Id || null;

    }
}

export interface IKeyValue {
    Key: string,
    Value: string
    Disabled?: boolean
}

export interface IContactModel {
    Id?: string;
    Phone?: string;
    MobilePhone?: string;
    Email: string;
    CreateDate?: string;
}

export interface IEntityModel {
    Id: string;
    Name: string;
    IdLocation?: string;
    IdContact?: string;
    IsSynchronized?: boolean;
    SynchronizedDate?: string;
    ShortName?: string;
    IsMain?: boolean;
    Location?: any;
    Contact?: any;
    Details?: any;
    EmailConfiguration?: string;
    MessageConfiguration?: string;
    CreateDate?: string;
}

export interface IFileModel {
    Id: number;
    IsActive?: boolean;
    PhysicalName?: string;
    OriginalName?: string;
    Type?: string;
    Path?: string;
    Code?: string;
    ExistInRepository?: boolean;
    ByteData?: string;
    UploadFileData?: string;
    Base64Data?: string;
    AvailableForCDN?: boolean;
    IsImageType?: boolean;
    IdAttachmentType?: number|null;
    IdFileType?: number|null;
    File?: File
}

export class AttachmentFile implements IFileModel {
    Id: number;
    OriginalName?: string;
    Type?: string;
    Path?: string;
    ByteData?: string;
    Base64Data?: string;
    IdAttachmentType?: number | null;
    IdFileType?: number | null;
    File?: File;

    constructor(data: Partial<IFileModel> = {}) {
        this.Id = data?.Id ?? null;
        this.OriginalName = data?.OriginalName || null;
        this.Type = data?.Type || null;
        this.Path = data?.Path || null;
        this.ByteData = data?.ByteData || null;
        this.Base64Data = data?.Base64Data || null;
        this.IdAttachmentType = data?.IdAttachmentType ?? null;
        this.IdFileType = data?.IdFileType ?? null;
        this.File = data?.File || null;
    }

    /**
     * Nome único do ficheiro para submissão — evita colisão no multipart/JSON quando 2 slots (ex: fatura e receita médica) têm o mesmo nome de origem.
     */
    static BuildUniqueName(idAttachmentType: number, filename: string, uniqueName: boolean = true): string {
        return uniqueName ? (new Date().getTime() + "_" + idAttachmentType + "_" + filename) : filename;
    }

    /**
     * Verifica pela extensão do nome se o ficheiro é uma imagem (fotografia) ou um documento.
     */
    static IsImage(originalName: string): boolean {
        return /\.(jpe?g|png|gif|webp|bmp)$/i.test(originalName || '');
    }
}

export enum EnumPlacesType {
    Continent = '1',
    Country = '2',
    District = '3',
    County = '4',
    Parish = '5'
}

export enum EnumDownloadFormatType {
    Unknown = 0,
    Excel = 1,
    PDF = 2
}

export enum EnumRequestTypes {
    SendFileToRepository = 1,
    SyncTemplateUsersPermissions = 90,

    /* [ Specific ] */
    ImportMerchantList = 101,
    ImportConsumersList = 102,
    ConsumptionRegistIntention = 103,
    ConsumptionProvisionalInvoice = 104,
    SaveWalletPayshop = 200,
    ImportConsumerHouseholdList = 210,
    ImportCampaignConsumerList = 211
}

// Ver estados comerciante
// export enum EnumStatus {
//     Pending = 1,
//     Accepted = 2,
//     Rejected = 3,
//     PendingResponsibleApproval = 4,
//     Finished = 5,
//     InProgress = 6,
//     Canceled = 7
// }

export enum EnumAttachmentsTypes {
    // Default
    NotDefined = 1,
    Image = 2,

    // Specific
    PermanentCertificateRegistration = 101,
    BeginningOfActivityDeclaration = 102,
    NoDebtToSocialSecurityDeclaration = 103,
    NoDebtToTaxAuthoritySecurityDeclaration = 104,
    SocialSecurityDeclaration = 105,
    BankAccountNumberProof = 106,
    InvoiceDocument = 108,
    MedicalReceipt = 121
}


/**
 * Default page number for the component of pagination
 */
export enum EnumPageRow {
    DEFAULT = 25,
    R25 = 25,
    R50 = 50,
    R100 = 100,
}

export enum EnumCurrencyCollection {
    /* [ Coins ]  */
    // [EnumCurrencyData(Id = (long)EnumCurrencyCollection.Euro, Name = "Euro", LangResource = "EuropeanUnionCurrency", Acronym = "EUR", Symbol = "€", Format = "C2", IsMain = true, IsBase = false, IsCoin = true)]
    Euro = 1,
    // [EnumCurrencyData(Id = (long)EnumCurrencyCollection.GB_Libra, Name = "Libra", LangResource = "BritishPound", Acronym = "GBP", Symbol = "£", Format = "C2", IsMain = false, IsBase = false, IsCoin = true)]
    GB_Libra = 2,
    // [EnumCurrencyData(Id = (long)EnumCurrencyCollection.US_Dollar, Name = "Dollar", LangResource = "AmericanDollar", Acronym = "USD", Symbol = "$", Format = "C2", IsMain = false, IsBase = true, IsCoin = true)]
    US_Dollar = 3,

    /* [ Credits ]  */
    // [EnumCurrencyData(Id = (long)EnumCurrencyCollection.Points, Name = "Points", LangResource = "Points", Acronym = "Pts", Symbol = "", Format = "C2", IsMain = false, IsBase = false, IsCoin = false)]
    Points = 1001,
}

export enum EnumDocumentType {

    NotDefined = 1,
    Image = 2,

    CC = 3,
    BI = 4,
    PASSPORT = 5,

    QRCodeMerchant = 21,
    PermanentCertificateRegistration = 101,
    BeginningOfActivityDeclaration = 102,
    NoDebtToSocialSecurityDeclaration = 103,
    NoDebtToTaxAuthoritySecurityDeclaration = 104,
    SocialSecurityDeclaration = 105,
    BankAccountNumberProof = 106,
    IdGovProof = 107,
    InvoiceDocument = 108,
    InvoiceRefundDocument = 109,
    CentralRegisterBeneficialOwner = 110,
    ProofOfLicense = 112, //module-200
    StorekeeperIdentificationProof = 113, //module-null
    ProofOfAddress = 111,
    ProofOfIdentity = 114,
    PROOFOFSTATUS = 119
}

export enum EnumWalletModules {
    SocialWallet = 200,
    PlusLocalCommerce = 201,
    MunicipalCard = 300,
    PessoalCard = 301
}

// Id do projeto de integração externa (ProjectExternalData.IdProject)
export enum EnumExternalProject {
    AMA = 8
}

// utilizar para verificar o tipo de codigo gerado/lido
export enum EnumQRCodeType {
    Card = 1, // nº cartão do utilizador
    Voucher = 2, // codigo de voucher / cupao
    Merchant = 3, // identidade do comerciante
    Consumption = 4, // pre-registo de consumo - utilizador
    CardAssociated = 5 // cartao associado do utilizador | tem regras diferentes
}